import Container from 'core/display/Container'
import Spine from 'core/display/Spine'
import { signal } from 'services/SignalsService'
import { animations } from 'settings/custom/win'
import { create } from 'utils/Object'

export default class WinSpine extends Container{
  constructor(data) {
    super()
    this._data = data

    this.createSignal()
  }

  createSignal() {
    signal.on('WIN-ANIMATE', this.animate.bind(this))
  }

  async animate(type) {
    const spine = new Spine(create(this._data, animations[type]))

    this.addChild(spine)

    await spine.play(type, false)

    this.removeChildren()

    signal.dispatch('WIN-ANIMATE:DONE')
  }
}
